// extracted by mini-css-extract-plugin
export default {"root":"MessageLinkeable_root__oaB58"};